import { useAuth } from '@/hooks/useAuth.ts';
import PsiPartnersPage from '@/pages/partners/PsiPartnersPage.tsx';
import InvestorPartnersPage from '@/pages/partners/InvestorPartnersPage.tsx';

export default function PartnersPage() {
  const { user } = useAuth();
  return user?.role === 'psi' ? <PsiPartnersPage /> : <InvestorPartnersPage />;
}
